import Image from './Image'

import './Gallery.css';

export default function Gallery({ list }) {
  return (
    <div className="gallery__container">
      {
        list.map(li => (
          <Image {...li} key={li.src} />
        ))
      }
    </div>
  )
}